import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from 'reactstrap';

const UploadDocumentModal = ({ isOpen, toggle, onSave }) => {
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTitle('');
      setFile(null);
      setErrors({});
    }
  }, [isOpen]);

  const validate = () => {
    const e = {};
    if (!title.trim()) e.title = 'Document title wajib diisi';
    if (!file) e.file = 'File wajib dipilih';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleUpload = () => {
    if (!validate()) return;
    onSave({ title: title.trim(), file });
    toggle();
  };

  const handleFileChange = e => {
    const selected = e.target.files?.[0] ?? null;
    setFile(selected);
    if (selected) setErrors(prev => ({ ...prev, file: undefined }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Upload Document</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>
            Document Title <span className='text-danger'>*</span>
          </Label>
          <Input
            type='text'
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder='Masukkan judul dokumen'
            invalid={!!errors.title}
          />
          {errors.title && <FormFeedback>{errors.title}</FormFeedback>}
        </FormGroup>
        <FormGroup>
          <Label>File</Label>
          <div className='d-flex align-items-center gap-2'>
            <Input
              type='text'
              readOnly
              value={file?.name ?? ''}
              placeholder='Belum ada file dipilih'
              invalid={!!errors.file}
              className='flex-grow-1'
            />
            <Button
              color='secondary'
              outline
              onClick={() => fileInputRef.current?.click()}
            >
              Browse File
            </Button>
          </div>
          {errors.file && (
            <div className='invalid-feedback d-block mt-1'>{errors.file}</div>
          )}
          <input
            type='file'
            ref={fileInputRef}
            className='d-none'
            onChange={handleFileChange}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color='light' onClick={toggle}>
          Cancel
        </Button>
        <Button color='primary' onClick={handleUpload}>
          Upload
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UploadDocumentModal;
